import { Navigate, useSearchParams } from 'react-router-dom';

import { getAbsoluteRoute } from '../../../../util/get-absolute-route';

export const ForwardToPharmacySelection = ({ drxId }: { drxId: string }) => {
    const [searchParams] = useSearchParams();

    return (
        <Navigate
            replace
            to={{
                pathname: getAbsoluteRoute('fill.drxId.pharmacy.root', {
                    drxId,
                }),
                search: `?${searchParams.toString()}`,
            }}
        />
    );
};
